import {
  showDanger,
  showInfo,
  showSuccess,
  showWarning,
} from 'containers/Toaster/actions';

import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { getSnoozedNotifications } from 'containers/App/Header/Notifications/snoozedNotifications';
import { type ReactNode, useMemo } from 'react';
import { useDispatch } from 'react-redux';

export type NotificationType = 'success' | 'warning' | 'danger' | 'info';

export interface ShowNotificationCommand {
  type: NotificationType;
  message: ReactNode | ((handleClose: () => void) => ReactNode);
  snoozeKey?: string;
  title?: string;
}

export interface NotificationsHook {
  showNotification: (command: ShowNotificationCommand) => void;
}

const showNotificationsByType = {
  danger: showDanger,
  warning: showWarning,
  info: showInfo,
  success: showSuccess,
};

export const useNotifications = (): NotificationsHook => {
  const dispatch = useDispatch();

  const showNotification = useStableCallback(
    (command: ShowNotificationCommand) => {
      const snoozedNotifications = getSnoozedNotifications();

      if (
        command.snoozeKey &&
        snoozedNotifications.includes(command.snoozeKey)
      ) {
        return;
      }

      dispatch(
        showNotificationsByType[command.type]({
          message: command.message,
          title: command.title,
          snoozeKey: command.snoozeKey,
        }),
      );
    },
  );

  return useMemo(
    () => ({
      showNotification,
    }),
    [],
  );
};
